var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 91,
    viewBox: "0 0 93 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.254545
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.5503 3.1452C57.5503 4.62018 56.3546 5.81596 54.8797 5.81596C53.4047 5.81596 52.209 4.62018 52.209 3.1452C52.209 1.6703 53.4047 0.474609 54.8797 0.474609C56.3546 0.474609 57.5503 1.6703 57.5503 3.1452Z",
    fill: "#1A1A1A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.590947
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.5303 9.44596L34.9442 10.3616C34.6571 10.5275 34.2899 10.429 34.1241 10.1419L31.2602 5.18147C31.0944 4.89439 31.1929 4.52724 31.4799 4.36151L33.0661 3.44574C33.3531 3.28001 33.7203 3.37836 33.8861 3.66545L36.75 8.62591C36.9158 8.91309 36.8174 9.28015 36.5303 9.44596Z",
    fill: "#1A1A1A"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.590947
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.79327 20.2234L10.15 20.3444C10.5545 20.4816 11.0007 20.4109 11.3431 20.1554L11.645 19.9301C12.5072 19.2867 13.733 19.9112 13.7192 20.9869L13.7144 21.3636C13.7089 21.7908 13.9139 22.1933 14.2627 22.4399L14.5703 22.6575C15.4487 23.2786 15.2334 24.6372 14.2062 24.9566L13.8464 25.0684C13.4384 25.1952 13.1191 25.5147 12.9924 25.9226L12.8804 26.2824C12.5612 27.3097 11.2025 27.5248 10.5813 26.6465L10.3637 26.3389C10.117 25.9902 9.71452 25.7851 9.28744 25.7906L8.91066 25.7953C7.83502 25.809 7.21054 24.5834 7.85392 23.7212L8.07932 23.4192C8.33482 23.0769 8.40544 22.6308 8.26824 22.2262L8.14722 21.8694C7.80177 20.8506 8.77442 19.8779 9.79327 20.2234Z",
    fill: "#FFC66D"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.590947
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.25971 39.139L7.66028 40.9261C7.73282 41.2496 7.52938 41.5708 7.20581 41.6432L1.61674 42.8961C1.29326 42.9686 0.972218 42.7651 0.899593 42.4416L0.499018 40.6545C0.426568 40.331 0.630006 40.0099 0.953493 39.9375L6.54264 38.6846C6.86613 38.6121 7.18717 38.8156 7.25971 39.139Z",
    fill: "#1A1A1A"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.590947
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9349 62.0026C12.9349 63.4775 11.7392 64.6732 10.2643 64.6732C8.78935 64.6732 7.59375 63.4775 7.59375 62.0026C7.59375 60.5277 8.78935 59.332 10.2643 59.332C11.7392 59.332 12.9349 60.5277 12.9349 62.0026Z",
    fill: "#1A1A1A"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.590947
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.79327 75.1531L10.15 75.2741C10.5545 75.4112 11.0007 75.3406 11.3431 75.0851L11.645 74.8597C12.5072 74.2164 13.733 74.8409 13.7192 75.9166L13.7144 76.2933C13.7089 76.7205 13.9139 77.123 14.2627 77.3697L14.5703 77.5871C15.4487 78.2084 15.2334 79.567 14.2062 79.8863L13.8464 79.9982C13.4384 80.125 13.1191 80.4444 12.9924 80.8523L12.8804 81.2121C12.5612 82.2394 11.2025 82.4546 10.5813 81.5762L10.3637 81.2687C10.117 80.9198 9.71452 80.7148 9.28744 80.7202L8.91066 80.7251C7.83502 80.7389 7.21054 79.5132 7.85392 78.651L8.07932 78.349C8.33482 78.0066 8.40544 77.5605 8.26824 77.1559L8.14722 76.7992C7.80177 75.7803 8.77442 74.8077 9.79327 75.1531Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.590947
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.5356 17.6805C77.7263 16.6257 77.9768 15.0545 79.0908 14.1998C80.2047 13.3451 81.7874 13.5097 82.5966 14.5645C82.5982 14.5665 82.5996 14.5685 82.6012 14.5704",
    stroke: "white",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.590947
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.7366 32.2293L86.0933 32.3503C86.4978 32.4875 86.9441 32.4168 87.2864 32.1613L87.5884 31.936C88.4507 31.2926 89.6763 31.9171 89.6625 32.9928L89.6577 33.3695C89.6523 33.7966 89.8574 34.1991 90.2061 34.4458L90.5137 34.6633C91.3921 35.2845 91.1769 36.6431 90.1496 36.9625L89.7897 37.0743C89.3817 37.2011 89.0625 37.5206 88.9357 37.9285L88.8238 38.2883C88.5045 39.3155 87.1458 39.5307 86.5247 38.6524L86.3072 38.3448C86.0604 37.996 85.658 37.7909 85.2308 37.7964L84.8541 37.8013C83.7784 37.8149 83.1538 36.5893 83.7973 35.7272L84.0226 35.4252C84.2781 35.0828 84.3488 34.6366 84.2115 34.232L84.0905 33.8753C83.7451 32.8565 84.7177 31.8838 85.7366 32.2293Z",
    fill: "#1A1A1A"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.590947
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.2317 63.8809C90.0477 64.12 91.3342 65.8949 91.0817 67.8127C90.8291 69.7305 89.127 71.1119 87.3111 70.8726C87.3076 70.8722 87.3042 70.8718 87.3008 70.8713",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.590947
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.5107 86.4109L80.9246 87.3266C80.6375 87.4923 80.2703 87.3939 80.1046 87.1068L77.2407 82.1465C77.0749 81.8592 77.1733 81.4921 77.4604 81.3264L79.0465 80.4106C79.3336 80.2448 79.7007 80.3432 79.8664 80.6304L82.7304 85.5908C82.8961 85.8779 82.7978 86.2451 82.5107 86.4109Z",
    fill: "#1A1A1A"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.590947
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5315 89.3035C29.4164 87.8503 29.7616 85.6856 31.2963 84.5081C32.831 83.3305 35.0113 83.5574 36.1263 85.0105L36.1327 85.0187",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.7254 44.9114C91.7254 69.136 72.0874 88.7741 47.8627 88.7741C23.6381 88.7741 4 69.136 4 44.9114C4 20.6867 23.6381 1.04883 47.8627 1.04883C72.0874 1.04883 91.7254 20.6867 91.7254 44.9114Z",
    fill: "#1A1A1A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.4162 44.9102C78.4162 61.7839 64.7372 75.463 47.8634 75.463C30.9896 75.463 17.3105 61.7839 17.3105 44.9102C17.3105 28.0363 30.9896 14.3574 47.8634 14.3574C64.7372 14.3574 78.4162 28.0363 78.4162 44.9102Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.375 44.9629L43.3319 53.9199L61.3494 35.9023",
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.a22e694facf2bc91bd2d56a64b3c1b08.svg";
export { ForwardRef as ReactComponent };